import { Route, Routes } from "react-router-dom";
import { Space } from "~/lib/types";
import { SpaceOrWorkspaceScope } from "~/hooks/useScope";
import CveEntryPage from "~/entry-pages/space/vulnerabilities/cve/[cveId]/CveEntryPage";
import AdvisoryEntryPage from "~/entry-pages/space/vulnerabilities/advisory/[advisoryId]/AdvisoryEntryPage";
import SoftwareEntryPage from "~/entry-pages/space/vulnerabilities/software/[softwareId]/SoftwareEntryPage";

type Props = {
  space: Space;
  scope: SpaceOrWorkspaceScope;
};

export function VulnsRoutes({ space, scope }: Props) {
  return (
    <Routes>
      <Route path="advisory">
        <Route
          path=":id/*"
          element={<AdvisoryEntryPage space={space} scope={scope} />}
        />
      </Route>

      <Route path="cve">
        <Route
          path=":id/*"
          element={<CveEntryPage space={space} scope={scope} />}
        />
      </Route>
      <Route path="software">
        <Route
          path=":id/*"
          element={<SoftwareEntryPage space={space} scope={scope} />}
        />
      </Route>
    </Routes>
  );
}
